import React from "react";
import Data from "../../Component/Products/data";

const MainData = () => {
	return <Data />;
};

export default MainData;
